import angular from 'angular';

import { svgUnit } from './svg.unit.directive';

export default angular.module('svg.unit', []).directive('svgUnit', svgUnit);
